const CheckMark = () => {
    return (
        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.5 12C7.28793 12 8.06815 11.8448 8.7961 11.5433C9.52405 11.2417 10.1855 10.7998 10.7426 10.2426C11.2998 9.68549 11.7417 9.02405 12.0433 8.2961C12.3448 7.56815 12.5 6.78793 12.5 6C12.5 5.21207 12.3448 4.43185 12.0433 3.7039C11.7417 2.97595 11.2998 2.31451 10.7426 1.75736C10.1855 1.20021 9.52405 0.758251 8.7961 0.456723C8.06815 0.155195 7.28793 -1.17411e-08 6.5 0C4.9087 2.37122e-08 3.38258 0.632141 2.25736 1.75736C1.13214 2.88258 0.5 4.4087 0.5 6C0.5 7.5913 1.13214 9.11742 2.25736 10.2426C3.38258 11.3679 4.9087 12 6.5 12ZM6.34533 8.42667L9.67867 4.42667L8.65467 3.57333L5.788 7.01267L4.30467 5.52867L3.362 6.47133L5.362 8.47133L5.878 8.98733L6.34533 8.42667Z"
                fill="#DFDFDF"
            />
        </svg>
    );
};

export default CheckMark;
